const wysiwygTables = document.querySelectorAll('table');
wysiwygTables.forEach((table) => {
  const element = document.createElement('div');
  element.classList.add('table-wrapper');
  table.parentNode.insertBefore(element, table);
  element.appendChild(table);
});
